import React from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useTranslation } from "react-i18next";
import SectionHeader from "@quest_editor/components/SectionHeader";
import InfoSection from "@quest_editor/components/InfoSection";
import SegmentTargetField, { Segment } from "./SegmentTargetField";
import SegmentExcludeField from "./SegmentExcludeField";

const OtherSection = ({
  expanded,
  onExpandedChange,
  targetSegmentRows,
  setTargetSegmentRows,
  excludeSegmentRows,
  setExcludeSegmentRows,
}: {
  expanded: boolean;
  onExpandedChange: (expanded: boolean) => void;
  targetSegmentRows: Segment[];
  setTargetSegmentRows: React.Dispatch<React.SetStateAction<Segment[]>>;
  excludeSegmentRows: Segment[];
  setExcludeSegmentRows: React.Dispatch<React.SetStateAction<Segment[]>>;
}) => {
  const { t } = useTranslation("questEditor");

  return (
    <Accordion
      expanded={expanded}
      onChange={(_, exp) => onExpandedChange(exp)}
      elevation={0}
      disableGutters
      sx={{
        border: 1,
        borderColor: "divider",
        "&:before": { display: "none" },
        ".MuiAccordionSummary-root .MuiSvgIcon-root": {
          transform: "rotate(0deg)",
        },
      }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon sx={{ color: "primary.contrastText" }} />}
        sx={{
          p: 0,
          minHeight: "unset",
          bgcolor: "primary.main",
          "&.Mui-expanded": { minHeight: "unset" },
          "& .MuiAccordionSummary-content": { m: 0, flexGrow: 1 },
          "& .MuiAccordionSummary-expandIconWrapper": {
            position: "absolute",
            right: 16,
          },
        }}
      >
        <SectionHeader title={t("quest_edit_target.section.other")} />
      </AccordionSummary>
      <AccordionDetails sx={{ p: 0 }}>
        <InfoSection
          rows={[
            {
              label: t("quest_edit_target.field.other.target_segment.name"),
              children: (
                <SegmentTargetField
                  segmentRows={targetSegmentRows}
                  setSegmentRows={setTargetSegmentRows}
                />
              ),
            },
            {
              label: t("quest_edit_target.field.other.exclude_segment.name"),
              children: (
                <SegmentExcludeField
                  segmentRows={excludeSegmentRows}
                  setSegmentRows={setExcludeSegmentRows}
                />
              ),
            },
          ]}
        />
      </AccordionDetails>
    </Accordion>
  );
};

export default OtherSection;
